import type { RouteObject } from "react-router-dom";
import AppError from "../app-error";
import NotificationsList, { notificationsLoader } from "./List";

export const notificationsRoutes: RouteObject[] = [
  { path: "notifications", Component: NotificationsList, loader: notificationsLoader, errorElement: <AppError /> },
];
